import _extends from 'babel-runtime/helpers/extends';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import createRequestInstance from './createRequestInstance';

/**
 * @param {Object<string, any>} config
 * @param {object} interceptors
 * @param {Array<function>} interceptors.request
 * @param {Array<function>} interceptors.response
 * @returns {Api}
 */
function createApi(config, interceptors) {
  /**
   * @var {AxiosInstance}
   */
  var _instance = null;
  /**
   * @var {Object<string, any>}
   */
  var _config = config;
  /**
   * @var {object}
   */
  var _interceptors = interceptors;

  var Api = function () {
    function Api() {
      _classCallCheck(this, Api);
    }

    _createClass(Api, [{
      key: 'fetch',


      /**
       * @public
       * @param {string} entry
       * @param {object} config
       * @returns {Promise}
       */
      value: function fetch(entry, config) {
        return this.request.get(entry, config);
      }

      /**
       * @public
       * @param {string} entry
       * @param {string|number} id
       * @param {object} config
       * @returns {Promise}
       */

    }, {
      key: 'fetchOne',
      value: function fetchOne(entry, id, config) {
        return this.request.get(entry + '/' + id, config);
      }

      /**
       * @public
       * @param {string} entry
       * @param {object} data
       * @param {object} config
       * @returns {Promise}
       */

    }, {
      key: 'create',
      value: function create(entry, data, config) {
        return this.request.post(entry, data, config);
      }

      /**
       * @public
       * @param {string} entry
       * @param {object} data
       * @param {object} config
       * @returns {Promise}
       */

    }, {
      key: 'update',
      value: function update(entry, data, config) {
        return this.request.put(entry, data, config);
      }

      /**
       * @public
       * @param {string} entry
       * @param {object} data
       * @param {string|number} id
       * @param {object} config
       * @returns {Promise}
       */

    }, {
      key: 'updateOne',
      value: function updateOne(entry, data, id, config) {
        return this.request.put(entry + '/' + id, data, config);
      }

      /**
       * @public
       * @param {string} entry
       * @param {object} config
       * @returns {Promise}
       */

    }, {
      key: 'remove',
      value: function remove(entry, config) {
        return this.request.delete(entry, config);
      }

      /**
       * @public
       * @param {string} entry
       * @param {string|id} id
       * @param {object} config
       * @returns {Promise}
       */

    }, {
      key: 'removeOne',
      value: function removeOne(entry, id, config) {
        return this.request.delete(entry + '/' + id, config);
      }
    }, {
      key: 'request',


      /**
       * @public
       * @returns {AxiosInstance}
       */
      get: function get() {
        return Api.getRequestInstance();
      }
    }], [{
      key: 'getRequestInstance',

      /**
       * @static
       * @returns {AxiosInstance}
       */
      value: function getRequestInstance() {
        if (!_instance) {
          _instance = createRequestInstance(_config, _interceptors);
        }
        return _instance;
      }
      /**
       * @static
       * @returns {Object<string, any>}
       */

    }, {
      key: 'getConfig',
      value: function getConfig() {
        return _config;
      }
      /**
       * @static
       * @param {Object<string, any>} config
       * @returns {Object<string, any>}
       */

    }, {
      key: 'setConfig',
      value: function setConfig(config) {
        _config = config;
        if (_instance) {
          _instance = createRequestInstance(_config, _interceptors);
        }
        return _config;
      }
      /**
       * @static
       * @param {Object<string, any>} config
       * @returns {Object<string, any>}
       */

    }, {
      key: 'updateConfig',
      value: function updateConfig(config) {
        return Api.setConfig(_extends({}, _config, config));
      }
      /**
       * @static
       * @returns {object}
       */

    }, {
      key: 'getInterceptors',
      value: function getInterceptors() {
        return _interceptors;
      }
      /**
       * @static
       * @param {object} interceptors
       * @param {Array<function>} interceptors.request
       * @param {Array<function>} interceptors.response
       * @returns {object}
       */

    }, {
      key: 'setInterceptors',
      value: function setInterceptors(interceptors) {
        _interceptors = interceptors;
        if (_instance) {
          _instance = createRequestInstance(_config, _interceptors);
        }
        return _interceptors;
      }
      /**
       * @static
       * @param {object} interceptors
       * @param {Array<function>} interceptors.request
       * @param {Array<function>} interceptors.response
       * @returns {object}
       */

    }, {
      key: 'updateInterceptors',
      value: function updateInterceptors(interceptors) {
        return Api.setInterceptors(_extends({}, _interceptors, interceptors));
      }
    }]);

    return Api;
  }();

  return Api;
}

export default createApi;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lyjs/es/request/createApi.js
// module id = 726
// module chunks = 0